'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style = require('./style');

var _colmo = require('../../mixins/colmo');

var _colmo2 = _interopRequireDefault(_colmo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  mixins: [_colmo2.default],
  props: {
    title: {
      type: String,
      default: '目录'
    },
    backgroundColor: {
      type: String,
      default: '#f9f9f9'
    },
    textColor: {
      type: String,
      default: ''
    },
    avatarIcon: {
      type: String,
      default: ''
    },
    hasMargin: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    themeStyle: function themeStyle() {
      var _theme = this._theme || 'default';
      return _style.STYLE_MAP[_theme] || _style.STYLE_MAP['default'];
    },
    textStyle: function textStyle() {
      var tmp = this.$theme.watchTheme({
        colmo: { color: this.textColor || '#1E2E37' }, // colmo模式 的 style
        default: { color: this.textColor || '#8E969B' }
      });
      return tmp;
    },
    imagePath: function imagePath() {
      return this.avatarIcon;
    }
  },
  methods: {
    _isHttpOrFile: function _isHttpOrFile(path) {
      return path.indexOf('http') === 0 || path.indexOf('file') === 0;
    },
    _getContext: function _getContext() {
      var url = weex.config.bundleUrl;
      if (url.indexOf('?') > 0) {
        url = url.substring(0, url.indexOf('?'));
      }
      url = url.split('/').slice(0, -2).join('/');
      if (this._isHttpOrFile(url)) {
        return url;
      } else {
        if (url.indexOf('/') === 0) {
          url = url.substring(url.indexOf('/') + 1);
        }
        url = 'file:///android_asset' + (url === '' ? '' : '/') + url;
      }
      return url;
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/script-loader.js!./~/babel-loader/lib!./~/weex-vue-loader/lib/selector.js?type=script&index=0!./packages/dof-catalog/index.vue
// module id = 315
// module chunks = 0 1